import React from "react";
import styles from "./FreeShippingBadge.module.scss";

function FreeShippingBadge() {
  return (
    <div className={styles.root}>
      <span className={styles.text}>Free Shipping</span>
    </div>
  );
}

export default FreeShippingBadge;
